(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-library"] && !Shopify.designMode) return;
  try {
    
  const drawer = document.getElementById('dd-drawer');
  if (drawer) {
    const content = drawer.querySelector('.dd-drawer__content');
    const soundBtn = drawer.querySelector('.dd-drawer__sound');
    const storyBtn = drawer.querySelector('.dd-drawer__story-toggle');
    const isTouch = window.matchMedia('(hover: none)').matches;

    const resetSound = () => {
      soundBtn.classList.remove('is-on');
      soundBtn.setAttribute('aria-pressed', 'false');
      soundBtn.hidden = !content.querySelector('video');
    };

    const openWeek = (weekId) => {
      const tpl = document.getElementById(`dd-week-${weekId}`);
      if (!tpl) return;
      content.replaceChildren(tpl.content.cloneNode(true));
      content.querySelector('.dd-drawer__video').append(soundBtn, storyBtn);
      storyBtn.setAttribute('aria-pressed', 'false');
      storyBtn.setAttribute('aria-label', 'Read story');
      storyBtn.hidden = !content.querySelector('[data-dd-story-flip]:not(:disabled)');
      drawer.showModal();
      const video = content.querySelector('video');
      if (video) video.play().catch(() => {});
      const flipCard = content.querySelector('[data-dd-story-flip]');
      if (flipCard && !flipCard.disabled) {
        const storyLabel = flipCard.getAttribute('aria-label');
        const setFlipped = (flipped) => {
          flipCard.classList.toggle('is-flipped', flipped);
          storyBtn.setAttribute('aria-pressed', String(flipped));
          storyBtn.setAttribute('aria-label', flipped ? 'Back to video' : 'Read story');
          flipCard.setAttribute('aria-pressed', String(flipped));
          flipCard.setAttribute('aria-label', flipped ? 'Back to video' : storyLabel);
          flipCard.querySelector('.dd-drawer__card-back').setAttribute('aria-hidden', String(!flipped));
          flipCard.querySelector('.dd-drawer__card-front').setAttribute('aria-hidden', String(flipped));
        };
        flipCard.addEventListener('click', () => setFlipped(!flipCard.classList.contains('is-flipped')));
        flipCard.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && !isTouch && !window.matchMedia('(max-width: 900px)').matches) setFlipped(true);
        });
        flipCard.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse' && !isTouch && !window.matchMedia('(max-width: 900px)').matches) setFlipped(false);
        });
      }
      resetSound();
      history.replaceState(null, '', `#${weekId}`);
    };

    const closeDrawer = () => {
      drawer.close();
    };

    drawer.addEventListener('close', () => {
      drawer.append(soundBtn, storyBtn);
      content.replaceChildren();
      history.replaceState(null, '', location.pathname + location.search);
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });

    drawer.querySelector('[data-dd-drawer-close]').addEventListener('click', closeDrawer);

    storyBtn.addEventListener('click', () => {
      content.querySelector('[data-dd-story-flip]:not(:disabled)')?.click();
    });

    soundBtn.addEventListener('click', () => {
      const video = content.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (!video.muted) video.play().catch(() => {});
      soundBtn.classList.toggle('is-on', !video.muted);
      soundBtn.setAttribute('aria-pressed', String(!video.muted));
    });

    const unflipAll = (except) => {
      document.querySelectorAll('[data-dd-week].is-flipped').forEach((c) => {
        if (c !== except) c.classList.remove('is-flipped');
      });
    };

    document.querySelectorAll('[data-dd-week]').forEach((card) => {
      card.addEventListener('click', () => {
        if (isTouch && !card.classList.contains('is-flipped')) {
          unflipAll(card);
          card.classList.add('is-flipped');
          return;
        }
        openWeek(card.dataset.ddWeek);
      });
    });

    if (location.hash.length > 1) {
      const weekId = decodeURIComponent(location.hash.slice(1));
      if (document.getElementById(`dd-week-${weekId}`)) openWeek(weekId);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-takeover"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const scenes = [...root.querySelectorAll('.dd-carousel__scene')];
    const count = root.querySelector('.dd-carousel__count');
    const live = root.querySelector('.dd-carousel__live');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0, busy = false, lastWheel = 0, wheelTotal = 0, wheelSign = 0, wheelConsumed = false, touch = null;
    const abort = new AbortController(), signal = abort.signal;
    function play(scene) { scene.querySelectorAll('video').forEach(v => v.play().catch(() => {})); }
    function pause(scene) { scene.querySelectorAll('video').forEach(v => { v.pause(); v.muted = true; }); scene.querySelectorAll('.dd-takeover__sound').forEach(b => { b.classList.remove('is-on'); b.setAttribute('aria-pressed','false'); }); }
    scenes.forEach((scene,i) => {
      scene.inert = i !== active;
      scene.setAttribute('aria-hidden',String(i !== active));
      const card = scene.querySelector('.dd-takeover__card');
      const video = card?.querySelector('.dd-takeover__front video');
      const sound = card?.querySelector('.dd-takeover__sound');
      if (sound && video) sound.addEventListener('click', e => { e.stopPropagation(); video.muted = !video.muted; video.play().catch(() => {}); sound.classList.toggle('is-on',!video.muted); sound.setAttribute('aria-pressed',String(!video.muted)); },{signal});
      else if (sound) sound.hidden = true;
      const storyButton = card?.querySelector('.dd-takeover__story-toggle');
      const setStory = (open) => {
        card.classList.toggle('is-flipped', open);
        storyButton?.setAttribute('aria-pressed', String(open));
        storyButton?.setAttribute('aria-label', open ? 'Back to video' : 'Read story');
      };
      if (storyButton) {
        storyButton.hidden = !card.querySelector('.dd-takeover__story');
        storyButton.addEventListener('click', e => { e.stopPropagation(); setStory(!card.classList.contains('is-flipped')); }, {signal});
      }
      if (card && window.matchMedia('(max-width: 900px)').matches) card.addEventListener('click',e => { if (!e.target.closest('button') && !root.dataset.swiping) setStory(!card.classList.contains('is-flipped')); },{signal});
      if (i !== active) pause(scene);
    });
    function move(direction) {
      if (busy || !root.isConnected) return;
      busy = true;
      const from = scenes[active], next = (active + direction + scenes.length) % scenes.length, to = scenes[next];
      const focused = from.contains(document.activeElement);
      from.inert = true; from.setAttribute('aria-hidden','true');
      to.style.visibility = 'visible';
      to.querySelector('.dd-takeover__card')?.classList.remove('is-flipped');
      const storyButton = to.querySelector('.dd-takeover__story-toggle');
      storyButton?.setAttribute('aria-pressed','false');
      storyButton?.setAttribute('aria-label','Read story');
      play(to);
      const options = {duration:reduced.matches ? 1 : 1000,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'};
      const exit = from.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(0,' + (-direction*100) + '%,0)'}],options);
      const enter = to.animate([{transform:'translate3d(0,' + (direction*100) + '%,0)'},{transform:'translate3d(0,0,0)'}],options);
      Promise.all([exit.finished,enter.finished]).then(() => {
        from.classList.remove('is-active'); to.classList.add('is-active'); to.style.visibility = ''; exit.cancel(); enter.cancel(); pause(from);
        active = next; to.inert = false; to.setAttribute('aria-hidden','false');
        count.textContent = (active+1) + ' / ' + scenes.length;
        live.textContent = to.getAttribute('aria-label');
        if (focused) root.querySelector('[data-step="' + direction + '"]').focus({preventScroll:true});
        busy = false; wheelTotal = 0;
      }).catch(() => {busy = false;});
    }
    root.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click',() => move(Number(b.dataset.step)),{signal}));
    root.addEventListener('wheel',e => {
      if (e.ctrlKey || Math.abs(e.deltaX)>Math.abs(e.deltaY) || e.target.closest('.dd-takeover__story')) return;
      e.preventDefault();
      const now = performance.now(), gap = now-lastWheel, dir = Math.sign(e.deltaY);
      lastWheel = now;
      if (gap>180 || dir!==wheelSign) {wheelTotal=0;wheelConsumed=false;}
      if (busy || wheelConsumed) {wheelTotal=0;return;}
      wheelSign=dir;
      wheelTotal+=Math.abs(e.deltaY)*(e.deltaMode===1?16:e.deltaMode===2?root.clientHeight:1);
      if (wheelTotal>=45) {wheelTotal=0;wheelConsumed=true;move(dir);}
    },{passive:false,signal});
    document.addEventListener('keydown',e => {
      if (e.altKey || e.ctrlKey || e.metaKey || e.target.closest('input,textarea,select,[contenteditable="true"],dialog,[role="dialog"]') || document.querySelector('dialog[open]')) return;
      if (e.key==='ArrowDown' || e.key==='ArrowUp') {e.preventDefault();if (!e.repeat) move(e.key==='ArrowDown'?1:-1);}
    },{signal});
    root.addEventListener('touchstart',e => {if(e.touches.length===1) touch={x:e.touches[0].clientX,y:e.touches[0].clientY};else touch=null;},{passive:true,signal});
    root.addEventListener('touchend',e => {
      if (!touch || !e.changedTouches.length) return;
      const dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;touch=null;
      if(Math.abs(dy)>55 && Math.abs(dy)>Math.abs(dx)) {root.dataset.swiping='true';move(dy<0?1:-1);setTimeout(() => delete root.dataset.swiping,350);}
    },{passive:true,signal});
    document.addEventListener('visibilitychange',() => {if(document.hidden) scenes.forEach(pause);else play(scenes[active]);},{signal});
    document.addEventListener('shopify:section:unload',e => {if(e.target.contains(root)) abort.abort();},{signal});
    play(scenes[active]);
  }
  document.querySelectorAll('.dd-carousel').forEach(init);
  document.addEventListener('shopify:section:load',e => e.target.querySelectorAll('.dd-carousel').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const stage = document.getElementById('dd-stage-img');
  const gallery = stage && stage.closest('.dd-pdp__gallery');
  const video = gallery && gallery.querySelector('#dd-stage-video');
  const sound = gallery && gallery.querySelector('.dd-pdp__sound');
  if (video && sound) {
    sound.addEventListener('click', () => {
      video.muted = !video.muted;
      sound.setAttribute('aria-pressed', String(!video.muted));
      sound.setAttribute('aria-label', video.muted ? 'Turn on sound' : 'Turn off sound');
      video.play().catch(() => {});
    });
  }
  const thumbs = gallery ? Array.from(gallery.querySelectorAll('.dd-pdp__thumb')) : [];
  if (stage && thumbs.length > 1) {
    let imageIndex = 0;
    const showImage = (index) => {
      imageIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[imageIndex];
      const isVideo = thumb.hasAttribute('data-dd-video');
      stage.hidden = isVideo;
      if (video && sound) {
        video.hidden = !isVideo;
        sound.hidden = !isVideo;
        if (isVideo) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.muted = true;
          sound.setAttribute('aria-pressed', 'false');
          sound.setAttribute('aria-label', 'Turn on sound');
        }
      }
      if (!isVideo) {
        stage.removeAttribute('srcset');
        stage.removeAttribute('sizes');
        stage.src = thumb.dataset.ddFull;
        stage.alt = thumb.dataset.ddAlt;
      }
      thumbs.forEach((item, i) => {
        item.classList.toggle('dd-pdp__thumb--active', i === imageIndex);
        item.setAttribute('aria-pressed', String(i === imageIndex));
      });
      gallery.querySelector('[data-dd-image-count]').textContent = (imageIndex + 1) + ' / ' + thumbs.length;
      const strip = thumb.parentElement;
      const itemRect = thumb.getBoundingClientRect();
      const stripRect = strip.getBoundingClientRect();
      if (itemRect.left < stripRect.left || itemRect.right > stripRect.right) {
        strip.scrollLeft += itemRect.left - stripRect.left - (strip.clientWidth - thumb.offsetWidth) / 2;
      }
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    gallery.querySelector('[data-dd-prev]').addEventListener('click', () => showImage(imageIndex - 1));
    gallery.querySelector('[data-dd-next]').addEventListener('click', () => showImage(imageIndex + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let touchStart = null;
    const tile = stage.parentElement;
    tile.addEventListener('touchstart', (event) => {
      touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    }, { passive: true });
    tile.addEventListener('touchend', (event) => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showImage(imageIndex + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    tile.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
  }

  const form = document.getElementById('dd-product-form');
  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('.dd-pdp__atc');
      const original = button.textContent;
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number(form.querySelector('[name="quantity"]').value || 1),
          }),
        });
        if (!response.ok) throw new Error('add failed');
        button.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('dd:cart:changed'));
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 1600);
      } catch (error) {
        button.textContent = original;
        button.disabled = false;
        window.location.href = '/cart';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
